import { render, staticRenderFns } from "./taxes.vue?vue&type=template&id=266310a0"
import script from "./taxes.vue?vue&type=script&lang=js"
export * from "./taxes.vue?vue&type=script&lang=js"
import style0 from "./taxes.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/stats/taxes.vue
// module id = 39Az
// module chunks = 0